import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Modal } from 'semantic-ui-react';
import { updateQueryString } from 'services/router/actions';
import { AppState } from 'services/types';
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';

export const SUPPORT_MODAL = 'supportModal';

function SupportModal(): JSX.Element {
    const dispatch = useDispatch();
    const open = useSelector((state: AppState) =>
        makeSelectQueryStringBooleanValue(SUPPORT_MODAL)(state)
    );

    const handleOnClose = (): void => {
        dispatch(updateQueryString({ [SUPPORT_MODAL]: undefined }));
    };

    return (
        <Modal
            open={open}
            onClose={handleOnClose}
            closeIcon
            centered={false}
            size="small"
        >
            <Modal.Header>Support</Modal.Header>
            <Modal.Content>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <p>
                                For internal T&G support, you can request it
                                through TAG Help. If you do not have access to
                                TAG Help, please email us at{' '}
                                <a href="mailto:support@orchardhand.com">
                                    support@orchardhand.com
                                </a>
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <p>
                                For user guide documentation, please access the
                                documentation{' '}
                                <a
                                    href="https://tandgdigital.atlassian.net/wiki/spaces/OHUD/overview"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    here
                                </a>
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Modal.Content>
        </Modal>
    );
}

export default SupportModal;
